// extracted by mini-css-extract-plugin
module.exports = {"AboutMe":"About_AboutMe__1mXOH","Me":"About_Me__2E3_Y","pulse":"About_pulse__2muV9"};